import { createContext, useContext, useEffect, useState } from 'react';
import { getAnalyticsByDates } from '../services/AnalyticsService';
import { analyticsRangeToDates } from '../utils';
import { DashboardContext } from './DashboardContext';
import { UserContext } from './UserContext';

interface OverviewContextProps {
  customRangeAnalytics?: any;
}

export const OverviewContext = createContext<OverviewContextProps>({});

export function OverviewContextProvider(props: any) {
  const { selectedAccount } = useContext(UserContext);
  const { analyticsRange } = useContext(DashboardContext);

  const [customRangeAnalytics, setCustomRangeAnalytics] = useState<any>();

  useEffect(() => {
    setCustomRangeAnalytics(undefined);

    if (!selectedAccount) {
      return;
    }

    const { startDate, endDate } = analyticsRangeToDates(analyticsRange);

    let relevant = true;
    getAnalyticsByDates(
      selectedAccount.id,
      'account',
      undefined,
      startDate,
      endDate,
    ).then((res) => {
      if (!relevant) return;

      setCustomRangeAnalytics(res);
    });

    return () => {
      relevant = false;
    };
  }, [selectedAccount, analyticsRange]);

  return (
    <OverviewContext.Provider value={{ customRangeAnalytics }}>
      {props.children}
    </OverviewContext.Provider>
  );
}
